import React from 'react';

import { Card } from "react-bootstrap";

const CustomCard = (props) => {
    const {titleHeader, titleBody} = props;
    return ( 
        <Card className="shadow mb-4">
            {titleHeader ? <Card.Header className="card-header py-3 m-0 font-weight-bold text-primary">{titleHeader}</Card.Header> : null }
            <Card.Body>
                {titleBody ? <Card.Title>{titleBody}</Card.Title> : null }
                <Card.Text >
                    {props.children}
                </Card.Text>
                                
            </Card.Body>
        </Card>                
     );
}
 
export default CustomCard;